export default "__VITE_ASSET__bh3UJLLe__"